import { render, staticRenderFns } from "./HorizontalCarousel.vue?vue&type=template&id=3aac8967&scoped=true"
import script from "./HorizontalCarousel.vue?vue&type=script&lang=js"
export * from "./HorizontalCarousel.vue?vue&type=script&lang=js"
import style0 from "./HorizontalCarousel.vue?vue&type=style&index=0&id=3aac8967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aac8967",
  null
  
)

export default component.exports